import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { OrgAdminSidebarComponent } from '../sidebar/org-admin-sidebar.component';
import { ContributionSetupComponent, ContributionSetupConfig } from '../../shared/components/contribution-setup/contribution-setup.component';
import { StepperStep } from '../../shared/components/primeng';

@Component({
  selector: 'app-org-admin-add-model',
  standalone: true,
  imports: [
    CommonModule,
    RouterModule,
    OrgAdminSidebarComponent,
    ContributionSetupComponent,
  ],
  templateUrl: './add-model.component.html',
  styleUrl: './add-model.component.scss',
})
export class OrgAdminAddModelComponent {
  config: ContributionSetupConfig = {
    type: 'model',
    routeBase: 'org-admin/add-model',
    setupTitle: 'Setup your Models',
    titlePlaceholder: 'Enter model title',
    localStorageKey: 'modelFormData',
    stepperSteps: [
      {
        key: 'step1',
        label: 'Setup your models',
      },
      {
        key: 'step2',
        label: 'Enter Metadata',
      },
      {
        key: 'step3',
        label: 'Additional Info',
      },
    ],
    routes: [
      'org-admin/add-model',
      'org-admin/add-model/metadata',
      'org-admin/add-model/additionalInfo'
    ]
  };
}
